import { useStaticQuery, graphql } from 'gatsby';
import { reduce } from 'lodash';

const getPathname = (url) => {
    const theUrl = new URL(url);

    if (theUrl) {
        return theUrl.pathname;
    }

    return url;
};

export const useAccountPaths = () => {
    const {
        wp: {
            accountPageSettings: {
                userAccountPageOptions: { pageConstants }
            }
        }
    } = useStaticQuery(graphql`
        query {
            wp {
                accountPageSettings {
                    userAccountPageOptions {
                        pageConstants {
                            accountSettings {
                                ... on WpAccountPage {
                                    uri
                                }
                            }
                            confirmCode {
                                ... on WpAccountPage {
                                    uri
                                }
                            }
                            confirmForgotPassword {
                                ... on WpAccountPage {
                                    uri
                                }
                            }
                            dashboard {
                                ... on WpAccountPage {
                                    uri
                                }
                            }
                            forgotPassword {
                                ... on WpAccountPage {
                                    uri
                                }
                            }
                            garages {
                                ... on WpAccountPage {
                                    uri
                                }
                            }
                            login {
                                ... on WpAccountPage {
                                    uri
                                }
                            }
                            myGiftCards {
                                ... on WpAccountPage {
                                    uri
                                }
                            }
                            preOrderedWashes {
                                ... on WpAccountPage {
                                    uri
                                }
                            }
                            registerAccount {
                                ... on WpAccountPage {
                                    uri
                                }
                            }
                            resendConfirmCode {
                                ... on WpAccountPage {
                                    uri
                                }
                            }
                            rewards {
                                ... on WpAccountPage {
                                    uri
                                }
                            }
                            signUp {
                                ... on WpAccountPage {
                                    uri
                                }
                            }
                            forceChangePassword {
                                ... on WpAccountPage {
                                    uri
                                }
                            }
                        }
                    }
                }
            }
        }
    `);

    return reduce(
        pageConstants,
        (carry, pageConstant, index) => {
            carry[index] = getPathname(pageConstant.uri);
            return carry;
        },
        {}
    );
};
